import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex w-full items-center justify-center pt-8 gap-1" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["onClick"]

import { ref, computed, PropType, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationControl',
  props: {
  selectedPage:{
    type:Number,
    default:1
  },
  perPage: {
    type: Number,
    default: 50,
  },
  gap: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
},
  emits: [
  "setPage",
],
  setup(__props, { emit }) {

const props = __props;





const currentPage = ref<number>(1);
const perPageSelect = ref(props.perPage);
const typeRange = ref<number>(0);
const showFirstPages = computed(() => currentPage.value <= 10);
const showLastPages = computed(() => currentPage.value > props.totalPages - 10);

const viewPageSelect = ref([
  { value: 0, label: "Por Defecto" },
  { value: 1, label: "0-10" },
  { value: 2, label: "0-20" },
  { value: 3, label: "0-40" },
  { value: 4, label: "0-60" },
  { value: 5, label: "0-100" },
  { value: 6, label: "0-150" },
]);

function onUpdateModel(value: number) {
  typeRange.value = value;
  switch (Number(typeRange.value)) {
    case 0:
      perPageSelect.value = props.perPage;
      break;
    case 1:
      perPageSelect.value = 10;
      break;
    case 2:
      perPageSelect.value = 20;
      break;
    case 3:
      perPageSelect.value = 40;
      break;
    case 4:
      perPageSelect.value = 60;
      break;
    case 5:
      perPageSelect.value = 100;
      break;
    case 6:
      perPageSelect.value = 150;
      break;
    default:
      break;
  }
  currentPage.value = 1;
}

const visiblePages = computed(() => {
  if (showFirstPages.value) {
    return Array.from(
      { length: Math.min(30, props.totalPages) },
      (_, index) => index + 1
    );
  } else if (showLastPages.value) {
    return Array.from(
      { length: Math.min(30, props.totalPages) },
      (_, index) => props.totalPages - 30 + index
    );
  } else {
    return Array.from(
      { length: 30 },
      (_, index) => currentPage.value - 5 + index
    );
  }
});


const goToPage = (page: number) => {
  if (page >= 1 && page <= props.totalPages) {
    currentPage.value = page;
    emit("setPage", currentPage.value);
  }
};
const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    emit("setPage", currentPage.value);
  }
};
const nextPage = () => {
  if (currentPage.value < props.totalPages) {
    currentPage.value++;
    emit("setPage", currentPage.value);
  }
};
const lastPage = () => {
  if (currentPage.value < props.totalPages) {
    currentPage.value = props.totalPages;
    emit("setPage", currentPage.value);
  }
};
const firstPage = () => {
  currentPage.value = 1;
  emit("setPage", currentPage.value);
};

watch(props, () => {
  currentPage.value = props.selectedPage
})


return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-double-left",
      disabled: currentPage.value === 1,
      onClick: firstPage
    }, null, 8, ["disabled"]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-left",
      disabled: currentPage.value === 1,
      onClick: previousPage
    }, null, 8, ["disabled"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visiblePages), (page) => {
        return (_openBlock(), _createElementBlock("span", {
          key: page,
          class: _normalizeClass([
          'cursor-pointer',
          'px-3',
          {
            'bg-[#008B4E] text-white font-bold': currentPage.value == page,
            'bg-[#F0F0F0] text-[#969393] ': currentPage.value !== page,
          },
        ]),
          onClick: ($event: any) => (goToPage(page))
        }, _toDisplayString(page), 11, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-right",
      disabled: currentPage.value === __props.totalPages,
      onClick: nextPage
    }, null, 8, ["disabled"]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-double-right",
      disabled: currentPage.value !== __props.totalPages,
      onClick: lastPage
    }, null, 8, ["disabled"])
  ]))
}
}

})